import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, y = 36, className = "", ...rest }) => (
    <motion.div
        className={className}
        initial={{ opacity: 0, y }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-70px" }}
        transition={{ duration: 0.75, delay, ease: [0.22, 1, 0.36, 1] }}
        {...rest}
    >
        {children}
    </motion.div>
);

export const SectionHeader = ({ eyebrow, title, sub, dark = true, align = "center" }) => (
    <div className={`mb-12 sm:mb-16 ${align === "center" ? "text-center mx-auto" : ""} max-w-3xl`}>
        <Reveal>
            <p className={dark ? "eyebrow" : "eyebrow !text-hotpink"}>{eyebrow}</p>
        </Reveal>
        <Reveal delay={0.08}>
            <h2 className={`mt-4 font-display text-4xl sm:text-5xl lg:text-6xl font-extrabold tracking-wide leading-[1.02] ${dark ? "text-white" : "text-noir"}`}>
                {title}
            </h2>
        </Reveal>
        {sub && (
            <Reveal delay={0.16}>
                <p className={`mt-5 text-sm sm:text-base leading-relaxed ${dark ? "text-zinc-400" : "text-zinc-600"}`}>{sub}</p>
            </Reveal>
        )}
    </div>
);
